export const SHOW_UPDATE_NOTIFICATION_SUCCESS =
  "API/UI/UPDATE_NOTIFICATION/SHOW_SUCCESS";
export const HIDE_UPDATE_NOTIFICATION_SUCCESS =
  "API/UI/UPDATE_NOTIFICATION/HIDE_SUCCESS";
